import ColorSection from './ColorSection';

export default ColorSection;
